import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export function useAuth() {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const user = accounts[0] ?? null;

  useEffect(() => {
    if (isAuthenticated) sessionStorage.removeItem("loginInProgress");
  }, [isAuthenticated]);

  const signIn = () => {
    sessionStorage.setItem("loginInProgress", "true");
    instance.loginRedirect(loginRequest);
  };
  const signOut = () => instance.logoutRedirect({ account: accounts[0] });

  const loginInProgress = sessionStorage.getItem("loginInProgress") === "true";

  return { isAuthenticated, user, signIn, signOut, inProgress, loginInProgress };
}
